import { faUser } from '@fortawesome/pro-regular-svg-icons/faUser';
import { faUsers } from '@fortawesome/pro-regular-svg-icons/faUsers';
import THEME, { COLOR } from '@maxpreps/shared/styles/colors';
import { appendClassName } from '@maxpreps/shared/styles/css';
import Icon from '@maxpreps/shared/ui/Icon/Icon';
import React from 'react';
import styled from 'styled-components';
import Image, { getSizeStyles, IPhotoProps } from './Image';

const StyledAvatarWrapper = styled.div<{
  $size: number | string;
  $maxSize?: number | string;
  $color: string;
}>`
  background-color: ${({ $color }) => $color};

  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  ${({ $size, $maxSize }) => getSizeStyles($size, $maxSize)};
`;

interface MugshotProps extends Omit<IPhotoProps, 'height' | 'width'> {
  size?: number;
  isGroup?: boolean;
  avatarFg?: string;
  avatarBg?: string;
}

const Mugshot: React.FC<MugshotProps> = ({
  size = 40,
  maxSize,
  isGroup,
  avatarFg = THEME.other.icon,
  avatarBg = COLOR.neutral10,
  className,
  borderRadius = '50%',
  src,
  alt,
  ...props
}) => {
  if (!src) {
    return (
      <StyledAvatarWrapper
        $size={size}
        $maxSize={maxSize}
        $color={avatarBg}
        className={appendClassName('photo-or-avatar', className)}
      >
        <Icon
          icon={isGroup ? faUsers : faUser}
          color={avatarFg}
          size={size * 0.6}
        />
      </StyledAvatarWrapper>
    );
  }

  return (
    <Image
      className={appendClassName('photo-or-avatar', className)}
      size={size}
      maxSize={maxSize}
      borderRadius={borderRadius}
      src={src}
      alt={alt}
      {...props}
    />
  );
};

export default Mugshot;
